import React, {Component} from 'react';
import styles from './styles.module.css';
import nextSvg from './next.svg'
import backSvg from './back.svg'
import closeSvg from './close.svg'
import Markdown from 'react-markdown';

export default class ProductsPreviewPopup extends Component{
    constructor(props){
        super(props)

        this.state = {
            selectedProductIndex: props.indexSelected
        }
    }
  

    handleClose = () => this.props.onClose()

    handleBack = () => {
        const {products=[]} = this.props;

        this.setState(state => ({
            selectedProductIndex: state.selectedProductIndex - 1 < 0 ? products.length : state.selectedProductIndex -1
        }))
    }

    handleNext = () => {
        const {products=[]} = this.props;

        this.setState(state => ({
            selectedProductIndex: state.selectedProductIndex + 1 >= products.length ? 0 : state.selectedProductIndex + 1
        }))
    }

    render() {
        const {products= [] } = this.props;
        const {selectedProductIndex = 0 } = this.state;
        const {name, photo: {url: photoUrl}, description} = products[selectedProductIndex];


        return (
            <div 
                className={styles.wrapper}>
                <div 
                    className={styles.background} 
                    onClick={this.handleClose}/>
                <div className={styles.content}>
                    <div 
                        className={styles.closeButton}
                        onClick={this.handleClose}>
                        <img src={closeSvg}/>
                    </div>
                    <div className={styles.product}>
                        <div className={styles.mainContentWrapper}>
                            {
                                <div className={styles.productName}>
                                    {name}
                                </div>        
                            }
                            <div
                                className={styles.productImage}
                                style={{backgroundImage: `url('${photoUrl}')`}}>

                                <div 
                                    className={styles.backButton}
                                    onClick={this.handleBack}>
                                    <img src={backSvg}/>
                                </div>
                                <div 
                                    className={styles.nextButton}
                                    onClick={this.handleNext}>
                                    <img src={nextSvg}/>
                                </div>
                            </div>
                        </div>

                        {
                            description ? (
                                <div className={styles.productDescription}>
                                    <Markdown source={description}/>
                                </div>
                            ): null
                        }
                    </div>
                </div>
            </div>
        )
    }
}